import React, { Component } from 'react';

class NotFound extends Component {
  render() {
    return (
      <div data-testid="page-not-found">
        <p>Página não encontrada!</p>
      </div>
    );
  }
}

export default NotFound;
